<template>
  <div class="order-list-page">
    <search-filter-new
      :campus="params.campusList"
      :items="searchItems"
      placeholder="请输入姓名"
      :hasFilter="hasFilter"
      @onCampus="chooseCampus"
      @onSearch="params.searchName = $event"
      @onExport="output"
      @onFilter="openFilter"
    />

    <van-tabs class="order-tabs" v-model="active">
      <van-tab class="tab-list" title="收费" :name="0"> </van-tab>
      <van-tab class="tab-list" title="转课" :name="1"> </van-tab>
      <van-tab class="tab-list" title="退费" :name="2"> </van-tab>
    </van-tabs>

    <order-list-tab ref="orderList" :params="params" :filterParams="filterParams" :orderType="active"></order-list-tab>
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import orderListTab from './child/order-list-tab.vue';
import emptyPage from '@teacher/components/empty-page.vue';
import { openOrderFiltrate } from './filtrate/index.js';

export default {
  name: 'order-list',
  components: {
    SearchFilterNew,
    orderListTab,
    emptyPage,
  },
  data() {
    return {
      pageTitle: '订单管理',
      active: parseInt(this.$vxRoute.query.active) || 0,      
      filterParams: {},
      params: {
        searchName: '',
        // 校区ID集合
        campusIds: [app.teacher.campusId],
        campusList: [app.teacher.campus],
      },
    };
  },
  computed: {
    searchItems () {
      let arr = ['campus','search'];
      if (app.permission.op('export_order')) {
        arr.push('export')
      }
      arr.push('filter')
      return arr;
    },
    hasFilter: function () {
      let fParams = this.filterParams;
      if (
        fParams.startTime ||
        fParams.endTime ||
        (fParams.teacherList && fParams.teacherList.length > 0) ||
        (fParams.sourceTypeList && fParams.sourceTypeList.length > 0) ||
        (fParams.productTypeList && fParams.productTypeList.length > 0) ||
        (fParams.orderStatusList && fParams.orderStatusList.length > 0) ||
        (fParams.oweFeeList && fParams.oweFeeList.length > 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    // 导出
    async output() {
      if (this.$refs.orderList.list.length == 0) {
        return vant.Toast.fail('没有可导出的数据');
      }
      let apis = {
        0: this.$api.doReport12,
        1: this.$api.doReport13,
        2: this.$api.doReport14,
        3: this.$api.doReport15,
      };
      await apis[this.active]({
        campusIds: this.params.campusIds,
        condition: this.$refs.orderList.apiParams,
      });

      vant.Dialog.alert({
        title: '已导出任务',
        message: `已创建导出任务，请登录云校电脑端（yunxiao.xiaogj.com）点击右上角“任务中心”下载导出文件。`,
        confirmButtonText: '确认',
      });
    },
    // 打开筛选
    async openFilter() {
      let res = await openOrderFiltrate({
        config: {
          orderType: this.active,
          campusIds: this.params.campusIds,
        },
        params: this.filterParams,
      });
      this.filterParams = {
        ...res.params,
      };
    },
  },
  watch: {
    active: {
      immediate: true,
      handler: function (nv, ov) {
        this.filterParams = {};
        if (nv == 0) {
          this.filterParams.orderStatusList = [0, 1, 2, 3];
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.order-list-page {
  display: flex;
  flex-direction: column;
  .order-tabs {
    ::v-deep .van-tabs__content {
      flex: 1;
      .tab-list {
        height: 100%;
      }
    }
  }
}
</style>